module.exports = __webpack_public_path__ + "static/media/retirement-date.b2be7c40.svg";